module.exports = __webpack_public_path__ + "img/smart_guided_camera.4eb17105.svg";